module.exports = __webpack_public_path__ + "media/images/carrinho_icone-cfa1ef713a41de2413dfd1deb96c18e6.png";